<script lang="ts">
	import { Menu, X, Search } from 'lucide-svelte';
	import ThemeToggle from '$lib/components/ThemeToggle.svelte';
	import OptimizedImage from '$lib/components/OptimizedImage.svelte';
	import DesktopNav from './DesktopNav.svelte';
	import MobileNav from './MobileNav.svelte';

	let membershipOpen = false;
	let mobileMembershipOpen = false;
	let mobileMenuOpen = false;
	let resourcesOpen = false;
	let mobileResourcesOpen = false;
	let netsOpen = false;
	let mobileNetsOpen = false;
	let calendarOpen = false;
	let mobileCalendarOpen = false;
</script>

<nav class="bg-blue-800 text-white dark:bg-blue-950">
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
		<div class="flex h-16 items-center justify-between">
			<div class="flex items-center">
				<a href="/" class="flex items-center space-x-3 transition-transform hover:scale-150">
					<OptimizedImage
						src="/logo.png"
						alt="DSARC Logo"
						class="h-10 w-auto"
						loading="eager"
						optimize={true}
						width={40}
						height={40}
					/>
					<span class="text-xl font-bold">DSARC</span>
				</a>
			</div>

			<!-- Desktop navigation and search -->
			<div class="hidden items-center space-x-4 md:flex">
				<DesktopNav bind:membershipOpen bind:resourcesOpen bind:netsOpen bind:calendarOpen />
				<a
					href="/search"
					class="flex items-center rounded-md p-2 text-gray-100 transition-colors hover:bg-blue-700"
					title="Search"
				>
					<Search class="h-5 w-5" />
					<span class="sr-only">Search</span>
				</a>
				<ThemeToggle />
			</div>

			<!-- Mobile controls -->
			<div class="flex items-center space-x-2 md:hidden">
				<a
					href="/search"
					class="rounded-md p-2 text-gray-100 transition-colors hover:bg-blue-700"
					title="Search"
				>
					<Search class="h-5 w-5" />
					<span class="sr-only">Search</span>
				</a>
				<ThemeToggle />
				<button
					type="button"
					class="inline-flex items-center justify-center rounded-md p-2 text-gray-100 hover:bg-blue-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-none focus:ring-inset"
					aria-controls="mobile-menu"
					aria-expanded={mobileMenuOpen}
					on:click={() => (mobileMenuOpen = !mobileMenuOpen)}
				>
					<span class="sr-only">Open main menu</span>
					{#if mobileMenuOpen}
						<X class="h-6 w-6" aria-hidden="true" />
					{:else}
						<Menu class="h-6 w-6" aria-hidden="true" />
					{/if}
				</button>
			</div>
		</div>

		<!-- Mobile navigation -->
		<MobileNav
			bind:mobileMenuOpen
			bind:mobileMembershipOpen
			bind:mobileResourcesOpen
			bind:mobileNetsOpen
			bind:mobileCalendarOpen
		/>
	</div>
</nav>
